exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button__bottom {\n    position: fixed;\n    bottom: 27px;\n    width: 265px;\n}\n.button__bottom_2 {\n    position: fixed;\n    bottom: 200px;\n    width: 265px;\n}\n.medium-draft--btn {\n    border: 0;\n    padding: 0;\n    margin-right: 5px;\n    margin-left: 5px;\n    margin-top: 3px;\n    outline: none;\n    cursor: pointer;\n}\n\n.button--videocam {\n    background-color: #46bc98;\n    display: block;\n    border-radius: 2px;\n    height: 18px;\n}\n\n.button--videocam:hover {\n    background-color: #542376;\n}\n\n.button--icon-videocam {\n    width: 18px!important;\n    height: 20px!important;\n    padding-bottom: 2px;\n    margin-top: -1px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/button.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/button.css
// module chunks = 0